'use strict';

var WidgetUtils = require('./WidgetUtils');
WidgetUtils.requireStylesheet('MITS.Widgets.ProgressBar');

var ProgressBar = function (container, options) {
    this.initialize(container, options);
};

ProgressBar.prototype = {

    //Constants
    BACKGROUND_IMAGE_PIXEL_WIDTH: 350,
    _FRAME_IMAGE_URL: 'images/Widgets/ProgressBar/progressBarFrame.gif',

    _progressImageNode: null,

    /**
     * @param container a DOM element or element's ID
     *        where the widget will render itself.
     */
    initialize: function (container) {
        var progressImg = document.createElement('img');
        progressImg.src = this._FRAME_IMAGE_URL;
        progressImg.className = 'progressBar';
        jQuery(container).append(progressImg);
        this._progressImageNode = progressImg;
        this.setPercentage(0);
    },

    /**
     * @param percentage A number between 0 and 100.
     */
    setPercentage: function (percentage) {
        var shadedBackgroundWidth = this.BACKGROUND_IMAGE_PIXEL_WIDTH / 2;
        var shadedPixelsToDisplay = shadedBackgroundWidth * (percentage / 100);
        var shadedPixelsToHide = shadedBackgroundWidth - shadedPixelsToDisplay;
        this._progressImageNode.style.backgroundPosition = '-' + shadedPixelsToHide + 'px 0px';
    }
};

module.exports = ProgressBar;


//////////////////
// WEBPACK FOOTER
// ./mits/Widgets/ProgressBar.js
// module id = 38
// module chunks = 0